import { create } from 'zustand'

type InboxNotificationsState = {
  unread_count: number
  total: number
  topId: number | null
  setMeta: (unread: number, total: number, topId: number | null) => void
}

export const useInboxNotificationsStore = create<InboxNotificationsState>((set) => ({
  unread_count: 0,
  total: 0,
  topId: null,
  setMeta: (unread_count, total, topId) => set({ unread_count, total, topId }),
}))
